const SweetAlertOptions = {
  confirmButtonColor: "#198754",
  denyButtonColor: "#ff8407",
  cancelButtonColor: "#dc3545",
};

export default SweetAlertOptions;
